import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SupportInfoBoxComponent } from './SupportInfoBox.component';

@NgModule({
    imports: [CommonModule],
    declarations: [SupportInfoBoxComponent],
    exports: [SupportInfoBoxComponent],
    providers: []
})
export class SupportInfoBoxModule {}
